"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function LoaderAnimation(config) {
    return {
        templateUrl: config.params.base + "templates/book/loader-animation.html"
    };
}
exports.default = angular.module('pb.loaderAnimation', [])
    .directive('pbLoaderAnimation', LoaderAnimation);
